import "../Styles/footer.css";
import { Link } from "react-router-dom";
import Logo from "../assets/QuadCode-256.png";
import { useLang } from "../i18n/useLang";
import Faq from "./Faq";
import ContactForm from "./ContactForm";
import { localizedPath } from "../i18n/routes";

function Footer({ showTopSections = true }) {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  const contact = t.home.footer.contact;
  const inboxEmail = "info@quadrocode.com";

  const privacyPolicyLabel =
    {
      en: "Privacy Policy",
      ar: "\u0633\u064a\u0627\u0633\u0629 \u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629",
      tr: "Gizlilik Politikas\u0131",
    }[lang] || "Privacy Policy";
  const aboutLabel =
    {
      en: "About",
      ar: "\u0645\u0646 \u0646\u062d\u0646",
      tr: "Hakk\u0131m\u0131zda",
    }[lang] || "About";

  return (
    <div className="footerCont" aria-label="Contact and FAQ section">
      {showTopSections && (
        <>
          <Faq faq={t.home.footer.faq} />
          <ContactForm contact={contact} inboxEmail={inboxEmail} />
        </>
      )}
      <div className="ThirdPart footerBottomBar">
        <div className="Left footerBrandCard">
          <div className="footerBottomMain">
            <div className="LogoCont">
              <img src={Logo} alt={t.home.footer.brand.logoAlt} className="Logo" width="96" height="96" loading="lazy" decoding="async" />
              <div className="footerBrandText">
                <span>{t.home.footer.brand.name}</span>
                <p>{t.home.footer.brand.taglineLine1} {t.home.footer.brand.taglineLine2}</p>
              </div>
            </div>

            <div className="footerBottomInfo">
              <p className="footerEmailLine">
                <strong>{contact.emailLabel}</strong>
                <span>info@quadrocode.com</span>
              </p>
              {contact.phone && (
                <p>
                  <strong>{contact.phoneLabel}:</strong> {contact.phone}
                </p>
              )}
              {contact.location && <p>{contact.location}</p>}
              <p>
                {t.home.footer.copyright.replace("{year}", String(year))}
              </p>
            </div>

            <div className="footerBottomActions">
              <Link to={localizedPath("/about", lang)} className="footerPolicyLink">
                {aboutLabel}
              </Link>
              <Link to={localizedPath("/privacy-policy", lang)} className="footerPolicyLink">
                {privacyPolicyLabel}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
